/* store.js — carousel, variant selection, AJAX add-to-cart */

document.addEventListener("DOMContentLoaded", () => {

  /* ---------- Carousel arrows ---------- */
  document.querySelectorAll(".arrow").forEach(btn => {
    btn.addEventListener("click", () => {
      const target = document.getElementById(btn.dataset.target);
      if (!target) return;
      const dir = btn.classList.contains("next") ? 1 : -1;
      target.scrollBy({ left: dir * 560, behavior: "smooth" });
    });
  });

  /* ---------- Mobile drawer ---------- */
  const drawer = document.getElementById("drawer");
  const scrim = document.getElementById("scrim");
  const openBtn = document.getElementById("drawerOpen");
  const closeBtn = document.getElementById("drawerClose");
  const closeDrawer = () => { drawer?.classList.remove("open"); scrim?.classList.remove("open"); };
  openBtn?.addEventListener("click", () => { drawer.classList.add("open"); scrim.classList.add("open"); });
  closeBtn?.addEventListener("click", closeDrawer);
  scrim?.addEventListener("click", closeDrawer);

  /* ---------- Reveal size row on "Choose Options" ---------- */
  document.querySelectorAll("[data-toggle-sizes]").forEach(btn => {
    btn.addEventListener("click", () => {
      const wrap = btn.closest("[data-product-form]");
      wrap.querySelector(".size-row")?.classList.toggle("open");
      wrap.querySelector("[data-measurements]")?.classList.toggle("open");
    });
  });

  /* ---------- Size selection -> resolve real variant ID, reveal Add to Cart ---------- */
  document.querySelectorAll(".size-row").forEach(row => {
    row.querySelectorAll("button[data-value]").forEach(sizeBtn => {
      sizeBtn.addEventListener("click", () => {
        row.querySelectorAll("button").forEach(b => b.classList.remove("selected"));
        sizeBtn.classList.add("selected");

        // In production: match against product.variants (passed via a
        // json script tag per card) to find the variant whose option
        // value equals sizeBtn.dataset.value, then set the hidden
        // input's value to that variant's real ID before submit.
        const form = row.closest("[data-product-form]");
        form.querySelector("[data-final-add]").style.display = "block";
      });
    });
  });

  /* ---------- Measurements modal (stub — wire to your real modal/app) ---------- */
  document.querySelectorAll("[data-measurements]").forEach(link => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      // Replace with a real modal, e.g. opening a <dialog> populated
      // from a product metafield containing the size chart.
      alert("Product measurement chart would open here.");
    });
  });

  /* ---------- AJAX add to cart for every card form ---------- */
  document.querySelectorAll(".card-action-form").forEach(form => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const formData = new FormData(form);
      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Accept": "application/json" },
          body: formData
        });
        if (!res.ok) throw new Error("Add to cart failed");
        await res.json();
        document.dispatchEvent(new CustomEvent("cart:updated"));
        // Update your cart icon count / open cart drawer here.
      } catch (err) {
        console.error(err);
        alert("Sorry, that item couldn't be added. Please try again.");
      }
    });
  });

  /* ---------- Mute/unmute for hero videos ---------- */
  document.querySelectorAll("[data-mute-toggle]").forEach(btn => {
    btn.addEventListener("click", () => {
      const video = btn.closest(".dual-panel")?.querySelector("video");
      if (!video) return;
      video.muted = !video.muted;
      btn.textContent = video.muted ? "Unmute" : "Mute";
    });
  });
});
